import styled from 'styled-components';

const StyledShadow = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 600px;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	opacity: 0.5;
`;

export { StyledShadow };
